import styled from 'styled-components';

export const Wrapper = styled.div<{ isInErrorState: boolean }>`
  ${({ theme }) => theme.fonts.regular.small}
  color: ${({ theme, isInErrorState }) =>
    isInErrorState ? theme.atlas.red.primary : theme.atlas.text.secondary};
`;
